export const SET_ORGANIZATION_INFO = "SET_ORGANIZATION_INFO";
